import React, { PureComponent, ReactNode } from "react";
import { Animated } from "react-animated-css";
import Navbar from "../../components/CustomNav/CustomNav.Component";

import { Container, MenuGrid, MenuGridItem } from "./TeacherMenu.styles";
import profileImg from "../../assets/images/mainmenus/profile.png";
import helpImg from "../../assets/images/mainmenus/help.png";
import assessmentImg from "../../assets/images/mainmenus/assessment.png";
import learnersImg from "../../assets/images/mainmenus/learners.png";
import skillsImg from "../../assets/images/mainmenus/skills.png";
import learningImg from "../../assets/images/mainmenus/perception.png";
import { currentBaseUrl, currentUser } from "src/common/services";

interface Props {
  history: any;
}
interface State {
  path: string;
}

const menuItems = [
  // {
  //   title: "Profile",
  //   description: "Amend or review any settings",
  //   color: "#acff24",
  //   bg: profileImg,
  //   to: currentBaseUrl() + "profile",
  // },
  {
    title: "Learners",
    description: "Deep dive into each of your learners profiles",
    color: "#ff7a03",
    bg: learnersImg,
    to: "/teachers/studentlist",
  },
  {
    title: "Alerts",
    description: "Explore the 5 Alert Levels",
    color: "#ff0b0b",
    bg: assessmentImg,
    to: "/teachers/home",
  },
  {
    title: "Perceptions",
    description: "Explore the 8 key perception indicators",
    color: "#3ee9f7",
    bg: learningImg,
    to: "/teachers/perceptions",
  },
  // {
  //   title: "Skills",
  //   description: "Explore the 7 pillars of meta-cognition",
  //   color: "#f143fc",
  //   bg: skillsImg,
  //   to: "/teachers/filter",
  // },
  {
    title: "Performance Center",
    description: "View your learner's progress on their learning pathways",
    color: "#acff24",
    bg: skillsImg,
    to: "/teachers/datacentre",
  },
  // {
  //   title: "Learner Activity",
  //   description: "View your most active and least active learners here",
  //   color: "#ff7a03",
  //   bg: skillsImg,
  //   to: "/teachers/learner-activity",
  // },
  {
    title: "Help",
    description: "Take a pit stop in the help center",
    color: "#9143fc",
    bg: helpImg,
    to: "helpcenter",
  },
];

class TeacherMenu extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      path: "",
    };
  }

  public onMenuItemClick = (path) => {
    if (path === "helpcenter") {
      window.open("https://myperformancelearning.com/blog/", "_blank");
      return;
    }
    this.props.history.push(path);
  };

  public onLogout = () => {
    this.props.history.replace("/login");
  };

  public render(): ReactNode {
    return (
      <Container>
        <Navbar logoutParent={this.onLogout} />
        <h1 className="menu-heading">
          Hey <span>{currentUser()}</span>
        </h1>
        <MenuGrid>
          {menuItems.map((item, i) => (
            <Animated
              animationIn="fadeInUp"
              animationOut="fadeOutUp"
              isVisible={true}
              animationInDuration={1000}
              key={`teacher_menu_item_${i}`}
            >
              <MenuGridItem
                highlightColor={item.color}
                backgroundImage={item.bg}
              >
                <div className="bg-holder" />

                <div className="menu-item-content">
                  <div>
                    <h2 className="menu-item-name">{item.title}</h2>
                    <p className="menu-item-description">{item.description}</p>
                  </div>
                  <button
                    onClick={this.onMenuItemClick.bind(this, item.to)}
                    className="menu-item-btn"
                  >
                    EXPLORE
                  </button>
                </div>
              </MenuGridItem>
            </Animated>
          ))}
        </MenuGrid>
      </Container>
    );
  }
}

export default TeacherMenu;



// WEBPACK FOOTER //
// ./src/pages/Teachers/TeacherMenu.Component.tsx